"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var theme_1 = require("../../../../mantine-theme/src");
var react_jss_1 = require("react-jss");
exports.default = react_jss_1.createUseStyles({
    hovered: {},
    item: function (_a) {
        var theme = _a.theme, color = _a.color;
        return (__assign(__assign({}, theme_1.getFontStyles(theme)), { WebkitTapHighlightColor: 'transparent', fontSize: theme.fontSizes.sm, border: 0, backgroundColor: 'transparent', outline: 0, width: '100%', textAlign: 'left', height: 32, padding: [0, theme.spacing.sm], cursor: 'pointer', color: color
                ? theme_1.getThemeColor({ theme: theme, color: color, shade: theme.colorScheme === 'dark' ? 4 : 6 })
                : theme.colorScheme === 'dark'
                    ? theme.colors.dark[0]
                    : theme.colors.gray[9], '&:disabled': {
                color: theme.colorScheme === 'dark' ? theme.colors.dark[4] : theme.colors.gray[5],
                cursor: 'not-allowed',
            }, '&$hovered:not(:disabled), &:not(:disabled):hover': {
                backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.colors.gray[1],
                '&:not(:disabled):active': {
                    backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[6] : theme.colors.gray[2],
                },
            } }));
    },
    inner: {
        display: 'flex',
        alignItems: 'center',
    },
    body: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flex: 1,
    },
    icon: function (_a) {
        var theme = _a.theme;
        return ({
            marginRight: theme.spacing.xs,
            '& > *': {
                display: 'block',
            },
        });
    },
    label: {
        lineHeight: 1,
    },
}, { link: true });
